"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * SR-SSB API
 * SR-SSB REST API suite
 *
 * The version of the OpenAPI document: 3.0
 * Contact: support@separatereality.co.uk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */
/**
 * The RefundAuthorization model module.
 * @module model/RefundAuthorization
 * @version 3.0
 */
var RefundAuthorization = /*#__PURE__*/function () {
  /**
   * Constructs a new <code>RefundAuthorization</code>.
   * @alias module:model/RefundAuthorization
   */
  function RefundAuthorization() {
    _classCallCheck(this, RefundAuthorization);
    RefundAuthorization.initialize(this);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  return _createClass(RefundAuthorization, null, [{
    key: "initialize",
    value: function initialize(obj) {}

    /**
     * Constructs a <code>RefundAuthorization</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/RefundAuthorization} obj Optional instance to populate.
     * @return {module:model/RefundAuthorization} The populated <code>RefundAuthorization</code> instance.
     */
  }, {
    key: "constructFromObject",
    value: function constructFromObject(data, obj) {
      if (data) {
        obj = obj || new RefundAuthorization();
        if (data.hasOwnProperty('refundId')) {
          obj['refundId'] = _ApiClient["default"].convertToType(data['refundId'], 'Number');
        }
        if (data.hasOwnProperty('approved')) {
          obj['approved'] = _ApiClient["default"].convertToType(data['approved'], 'Boolean');
        }
        if (data.hasOwnProperty('customerId')) {
          obj['customerId'] = _ApiClient["default"].convertToType(data['customerId'], 'Number');
        }
        if (data.hasOwnProperty('orderId')) {
          obj['orderId'] = _ApiClient["default"].convertToType(data['orderId'], 'Number');
        }
        if (data.hasOwnProperty('orderRefId')) {
          obj['orderRefId'] = _ApiClient["default"].convertToType(data['orderRefId'], 'String');
        }
        if (data.hasOwnProperty('refundRefId')) {
          obj['refundRefId'] = _ApiClient["default"].convertToType(data['refundRefId'], 'String');
        }
        if (data.hasOwnProperty('refundLegacyId')) {
          obj['refundLegacyId'] = _ApiClient["default"].convertToType(data['refundLegacyId'], 'String');
        }
        if (data.hasOwnProperty('receiptNo')) {
          obj['receiptNo'] = _ApiClient["default"].convertToType(data['receiptNo'], 'String');
        }
        if (data.hasOwnProperty('transactionNo')) {
          obj['transactionNo'] = _ApiClient["default"].convertToType(data['transactionNo'], 'String');
        }
        if (data.hasOwnProperty('gateway')) {
          obj['gateway'] = _ApiClient["default"].convertToType(data['gateway'], 'String');
        }
        if (data.hasOwnProperty('operator')) {
          obj['operator'] = _ApiClient["default"].convertToType(data['operator'], 'String');
        }
        if (data.hasOwnProperty('processDate')) {
          obj['processDate'] = _ApiClient["default"].convertToType(data['processDate'], 'Date');
        }
        if (data.hasOwnProperty('card')) {
          obj['card'] = _ApiClient["default"].convertToType(data['card'], 'Boolean');
        }
        if (data.hasOwnProperty('cardType')) {
          obj['cardType'] = _ApiClient["default"].convertToType(data['cardType'], 'String');
        }
        if (data.hasOwnProperty('paymentType')) {
          obj['paymentType'] = _ApiClient["default"].convertToType(data['paymentType'], 'String');
        }
        if (data.hasOwnProperty('amount')) {
          obj['amount'] = _ApiClient["default"].convertToType(data['amount'], 'Number');
        }
        if (data.hasOwnProperty('amountApproved')) {
          obj['amountApproved'] = _ApiClient["default"].convertToType(data['amountApproved'], 'Number');
        }
        if (data.hasOwnProperty('amountCaptured')) {
          obj['amountCaptured'] = _ApiClient["default"].convertToType(data['amountCaptured'], 'Number');
        }
        if (data.hasOwnProperty('amountRefunded')) {
          obj['amountRefunded'] = _ApiClient["default"].convertToType(data['amountRefunded'], 'Number');
        }
        if (data.hasOwnProperty('amountUnits')) {
          obj['amountUnits'] = _ApiClient["default"].convertToType(data['amountUnits'], 'String');
        }
        if (data.hasOwnProperty('amountCurrency')) {
          obj['amountCurrency'] = _ApiClient["default"].convertToType(data['amountCurrency'], 'String');
        }
        if (data.hasOwnProperty('message')) {
          obj['message'] = _ApiClient["default"].convertToType(data['message'], 'String');
        }
        if (data.hasOwnProperty('messageCode')) {
          obj['messageCode'] = _ApiClient["default"].convertToType(data['messageCode'], 'String');
        }
        if (data.hasOwnProperty('date')) {
          obj['date'] = _ApiClient["default"].convertToType(data['date'], 'Date');
        }
        if (data.hasOwnProperty('basketRefId')) {
          obj['basketRefId'] = _ApiClient["default"].convertToType(data['basketRefId'], 'String');
        }
        if (data.hasOwnProperty('token')) {
          obj['token'] = _ApiClient["default"].convertToType(data['token'], 'String');
        }
        if (data.hasOwnProperty('tokenDetails')) {
          obj['tokenDetails'] = _ApiClient["default"].convertToType(data['tokenDetails'], 'String');
        }
      }
      return obj;
    }

    /**
     * Validates the JSON data with respect to <code>RefundAuthorization</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>RefundAuthorization</code>.
     */
  }, {
    key: "validateJSON",
    value: function validateJSON(data) {
      // ensure the json data is a string
      if (data['orderRefId'] && !(typeof data['orderRefId'] === 'string' || data['orderRefId'] instanceof String)) {
        throw new Error("Expected the field `orderRefId` to be a primitive type in the JSON string but got " + data['orderRefId']);
      }
      // ensure the json data is a string
      if (data['refundRefId'] && !(typeof data['refundRefId'] === 'string' || data['refundRefId'] instanceof String)) {
        throw new Error("Expected the field `refundRefId` to be a primitive type in the JSON string but got " + data['refundRefId']);
      }
      // ensure the json data is a string
      if (data['refundLegacyId'] && !(typeof data['refundLegacyId'] === 'string' || data['refundLegacyId'] instanceof String)) {
        throw new Error("Expected the field `refundLegacyId` to be a primitive type in the JSON string but got " + data['refundLegacyId']);
      }
      // ensure the json data is a string
      if (data['receiptNo'] && !(typeof data['receiptNo'] === 'string' || data['receiptNo'] instanceof String)) {
        throw new Error("Expected the field `receiptNo` to be a primitive type in the JSON string but got " + data['receiptNo']);
      }
      // ensure the json data is a string
      if (data['transactionNo'] && !(typeof data['transactionNo'] === 'string' || data['transactionNo'] instanceof String)) {
        throw new Error("Expected the field `transactionNo` to be a primitive type in the JSON string but got " + data['transactionNo']);
      }
      // ensure the json data is a string
      if (data['gateway'] && !(typeof data['gateway'] === 'string' || data['gateway'] instanceof String)) {
        throw new Error("Expected the field `gateway` to be a primitive type in the JSON string but got " + data['gateway']);
      }
      // ensure the json data is a string
      if (data['operator'] && !(typeof data['operator'] === 'string' || data['operator'] instanceof String)) {
        throw new Error("Expected the field `operator` to be a primitive type in the JSON string but got " + data['operator']);
      }
      // ensure the json data is a string
      if (data['cardType'] && !(typeof data['cardType'] === 'string' || data['cardType'] instanceof String)) {
        throw new Error("Expected the field `cardType` to be a primitive type in the JSON string but got " + data['cardType']);
      }
      // ensure the json data is a string
      if (data['paymentType'] && !(typeof data['paymentType'] === 'string' || data['paymentType'] instanceof String)) {
        throw new Error("Expected the field `paymentType` to be a primitive type in the JSON string but got " + data['paymentType']);
      }
      // ensure the json data is a string
      if (data['amountUnits'] && !(typeof data['amountUnits'] === 'string' || data['amountUnits'] instanceof String)) {
        throw new Error("Expected the field `amountUnits` to be a primitive type in the JSON string but got " + data['amountUnits']);
      }
      // ensure the json data is a string
      if (data['amountCurrency'] && !(typeof data['amountCurrency'] === 'string' || data['amountCurrency'] instanceof String)) {
        throw new Error("Expected the field `amountCurrency` to be a primitive type in the JSON string but got " + data['amountCurrency']);
      }
      // ensure the json data is a string
      if (data['message'] && !(typeof data['message'] === 'string' || data['message'] instanceof String)) {
        throw new Error("Expected the field `message` to be a primitive type in the JSON string but got " + data['message']);
      }
      // ensure the json data is a string
      if (data['messageCode'] && !(typeof data['messageCode'] === 'string' || data['messageCode'] instanceof String)) {
        throw new Error("Expected the field `messageCode` to be a primitive type in the JSON string but got " + data['messageCode']);
      }
      // ensure the json data is a string
      if (data['basketRefId'] && !(typeof data['basketRefId'] === 'string' || data['basketRefId'] instanceof String)) {
        throw new Error("Expected the field `basketRefId` to be a primitive type in the JSON string but got " + data['basketRefId']);
      }
      // ensure the json data is a string
      if (data['token'] && !(typeof data['token'] === 'string' || data['token'] instanceof String)) {
        throw new Error("Expected the field `token` to be a primitive type in the JSON string but got " + data['token']);
      }
      // ensure the json data is a string
      if (data['tokenDetails'] && !(typeof data['tokenDetails'] === 'string' || data['tokenDetails'] instanceof String)) {
        throw new Error("Expected the field `tokenDetails` to be a primitive type in the JSON string but got " + data['tokenDetails']);
      }
      return true;
    }
  }]);
}();
/**
 * @member {Number} refundId
 */
RefundAuthorization.prototype['refundId'] = undefined;

/**
 * @member {Boolean} approved
 */
RefundAuthorization.prototype['approved'] = undefined;

/**
 * @member {Number} customerId
 */
RefundAuthorization.prototype['customerId'] = undefined;

/**
 * @member {Number} orderId
 */
RefundAuthorization.prototype['orderId'] = undefined;

/**
 * @member {String} orderRefId
 */
RefundAuthorization.prototype['orderRefId'] = undefined;

/**
 * @member {String} refundRefId
 */
RefundAuthorization.prototype['refundRefId'] = undefined;

/**
 * @member {String} refundLegacyId
 */
RefundAuthorization.prototype['refundLegacyId'] = undefined;

/**
 * @member {String} receiptNo
 */
RefundAuthorization.prototype['receiptNo'] = undefined;

/**
 * @member {String} transactionNo
 */
RefundAuthorization.prototype['transactionNo'] = undefined;

/**
 * @member {String} gateway
 */
RefundAuthorization.prototype['gateway'] = undefined;

/**
 * @member {String} operator
 */
RefundAuthorization.prototype['operator'] = undefined;

/**
 * @member {Date} processDate
 */
RefundAuthorization.prototype['processDate'] = undefined;

/**
 * @member {Boolean} card
 */
RefundAuthorization.prototype['card'] = undefined;

/**
 * @member {String} cardType
 */
RefundAuthorization.prototype['cardType'] = undefined;

/**
 * @member {String} paymentType
 */
RefundAuthorization.prototype['paymentType'] = undefined;

/**
 * @member {Number} amount
 */
RefundAuthorization.prototype['amount'] = undefined;

/**
 * @member {Number} amountApproved
 */
RefundAuthorization.prototype['amountApproved'] = undefined;

/**
 * @member {Number} amountCaptured
 */
RefundAuthorization.prototype['amountCaptured'] = undefined;

/**
 * @member {Number} amountRefunded
 */
RefundAuthorization.prototype['amountRefunded'] = undefined;

/**
 * @member {String} amountUnits
 */
RefundAuthorization.prototype['amountUnits'] = undefined;

/**
 * @member {String} amountCurrency
 */
RefundAuthorization.prototype['amountCurrency'] = undefined;

/**
 * @member {String} message
 */
RefundAuthorization.prototype['message'] = undefined;

/**
 * @member {String} messageCode
 */
RefundAuthorization.prototype['messageCode'] = undefined;

/**
 * @member {Date} date
 */
RefundAuthorization.prototype['date'] = undefined;

/**
 * @member {String} basketRefId
 */
RefundAuthorization.prototype['basketRefId'] = undefined;

/**
 * @member {String} token
 */
RefundAuthorization.prototype['token'] = undefined;

/**
 * @member {String} tokenDetails
 */
RefundAuthorization.prototype['tokenDetails'] = undefined;
var _default = exports["default"] = RefundAuthorization;